<template>
  <div>
    <GoBackView />
    <MineHeaderView @click-icon="openMenu" />
    <MineMenuView ref="mmv" />
    <WallerStatistics @reset-record="resetRecord" :usr="usrData" />
    <WallerRecordView ref="record" />
  </div>
</template>

<script>
import { Dialog } from 'vant'
import GoBackView from '@/components/goback/index.vue'
import {
  MineHeaderView,
  MineMenuView,
  WallerStatistics,
  WallerRecordView
} from './components/index'
export default {
  name: 'MineWalletView',
  components: {
    MineHeaderView,
    MineMenuView,
    WallerStatistics,
    WallerRecordView,
    GoBackView
  },
  data () {
    return {
      billData: null,
      usrData: null
    }
  },
  mounted () {
    this.getUsr()
  },
  methods: {
    async getUsr () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        this.usrData = res.data
        if (this.usrData.has_wallet != 1) {
          Dialog.alert({
            title: '提示',
            message: '请先绑定您的提款地址'
          }).then(() => {
            this.$router.push(
              {
                name: 'mine'
              },
              () => {}
            )
          })
        }
        if (this.usrData.wstatus != 1) {
          Dialog.alert({
            title: '提示',
            message: this.usrData.wremark
          }).then(() => {
            // on close
          })
        }
      })
    },
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    resetRecord () {
      const that = this
      this.$nextTick(() => {
        that.$refs.record.onLoad()
      })
    }
  }
}
</script>

<style></style>
